import { RequireAgent } from "@procurement-agents/auth";
import type { ScopeApi } from "@procurement-agents/scope-api";
import { useEffect, useState } from "react";
import { Route, Routes } from "react-router-dom";
import { ScopeApiProvider, useScopeApi } from "../api";
import { DraftEditor } from "./DraftEditor";
import { ExportTemplates } from "./ExportTemplates";
import { TemplatesList } from "./TemplatesList";
import { TemplateView } from "./TemplateView";

/** Template management (SPEC_SLICE4 section 7), mounted by the shell under /templates/*. */
export function TemplatesApp({ api }: { api?: ScopeApi }) {
  return (
    <RequireAgent id="scope">
      <ScopeApiProvider api={api}><TemplatesRoutes /></ScopeApiProvider>
    </RequireAgent>
  );
}

function TemplatesRoutes() {
  const { api } = useScopeApi();
  const [refs, setRefs] = useState<string[]>([]);
  const [domains, setDomains] = useState<Array<{ id: string; name: string }>>([]);
  const [categories, setCategories] = useState<string[]>([]);
  useEffect(() => { api.tenant().then((t) => { setRefs(t.reference_tables.map((r) => r.id)); setDomains((t as { sme_domains?: Array<{ id: string; name: string }> }).sme_domains ?? []); setCategories(t.default_categories ?? []); }).catch(() => {}); }, [api]);
  return (
    <Routes>
      <Route index element={<TemplatesList />} />
      <Route path="letterheads" element={<ExportTemplates />} />
      <Route path=":id" element={<TemplateView referenceTables={refs} />} />
      <Route path=":id/draft" element={<DraftEditor referenceTables={refs} domains={domains} categories={categories} />} />
    </Routes>
  );
}
